const isFeatureEnabled = (features, feature) =>
  !!features && features[feature] === 'on';

export default isFeatureEnabled;
